<template>
  <base-autocomplete-chooser :active="true">
    <autocomplete v-click-outside="clickedOutside" :value="selectedOption" autocomplete :items="currentlySelectedValues"
                  :get-label="valueForOption" :component-item="template" :min-len="0" :keep-open="true"
                  :auto-select-one-item="false"
                  :input-attrs="{placeholder: i18n.t('components.autocomplete.prompt')}"
                  @input="updateSelectedOption" @update-items="updateSearchText" @item-selected="chooseOption" />
  </base-autocomplete-chooser>
</template>

<script>
import Autocomplete from '@/components/inputs/autocomplete'
import { markRaw } from 'vue'
import MultiSelectChooserOption from './multi-select-chooser-option'
import BaseAutocompleteChooser from '../../../components/inputs/base-autocomplete-chooser'

export default {
  components: { Autocomplete, BaseAutocompleteChooser },

  props: {
    options: {
      type: Array,
      required: true
    },
    existingValues: {
      type: Array,
      required: true
    }
  },

  emits: ['clicked-outside', 'item-selected'],

  data() {
    return {
      selectedOption: null,
      template: markRaw(MultiSelectChooserOption),
      searchText: null
    }
  },

  computed: {
    currentlySelectedValues() {
      const filteredOptions =  this.options.filter(opt => !this.alreadyHasOption(opt))
      if (this.searchText === null || this.searchText === '') {
        return filteredOptions
      } else {
        return filteredOptions.filter(opt => opt[0].match(new RegExp(this.searchText, 'i')))
      }
    }
  },

  methods: {
    chooseOption(item) {
      this.$emit('item-selected', item)
    },

    clickedOutside() {
      this.$emit('clicked-outside')
    },

    alreadyHasOption(option) {
      for (let opt of this.existingValues) {
        if (option[1] === opt[1]) {
          return true
        }
      }
      return false
    },

    updateSearchText(searchText) {
      this.searchText = searchText
    },

    updateSelectedOption(value) {
      this.selectedOption = value
    },

    displayNameForOption(option) {
      return option[0]
    },

    valueForOption(option) {
      return option[1]
    }
  }
}
</script>

